import { render, staticRenderFns } from "./ticket_subcategory_dropdown.vue?vue&type=template&id=22798f7d&scoped=true&"
import script from "./ticket_subcategory_dropdown.vue?vue&type=script&lang=js&"
export * from "./ticket_subcategory_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22798f7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22798f7d')) {
      api.createRecord('22798f7d', component.options)
    } else {
      api.reload('22798f7d', component.options)
    }
    module.hot.accept("./ticket_subcategory_dropdown.vue?vue&type=template&id=22798f7d&scoped=true&", function () {
      api.rerender('22798f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_subcategory_dropdown.vue"
export default component.exports